// extracted by mini-css-extract-plugin
module.exports = {"root":"FixedLoader_root__vEcJS","fadeIn":"FixedLoader_fadeIn__2fhQk"};